import useCheckIn from "../../../../data/useCheckIn";

export default function LeadCheckInStatusCell({
  checkInId,
}: {
  checkInId?: string | null;
}) {
  const { checkInItems, checkInSteps } = useCheckIn(undefined, checkInId ?? undefined);
  const totalSteps = checkInSteps.data?.data?.length ?? 0;
  const activeStepCount = Math.max(totalSteps, 0);

  if (!checkInId) {
    return <span>0/{activeStepCount}</span>;
  }

  if (checkInItems.isLoading) {
    return <span>.../{activeStepCount}</span>;
  }

  const completedStepCount = (checkInItems.data?.data ?? []).filter((item) => !!item.completed).length;
  return <span>{completedStepCount}/{activeStepCount}</span>;
}
